
export class LiveChannel {
    public info: string;
    public channelId: string;

    constructor(info: string, channelId: string) {
        this.info = info;
        this.channelId = channelId;
    }
}

export const LiveSetting = {
    backgroundStyle: {
        white: 'base-color-white',
        dark: 'base-color',
        lighter: 'base-color-lighter'
    },
    liveChannel: {
        stock: new LiveChannel('stock', 'UCKYI3oKkE36sJl3vnL9DV-A'),
        advisory: new LiveChannel('assessoria', 'UCxrB8yGIrTWPAN17knREhgA')
    }
}
